// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-section[data-v-0ae60a48]{height:100vh}.btn-open-icon[data-v-0ae60a48]{margin-left:-9px}.btn-open[data-v-0ae60a48]{position:fixed;top:40%;border-radius:0 5px 5px 0;width:20px;height:59px;z-index:20}.pStyle[data-v-0ae60a48]{fontSize:16px;color:rgba(0,0,0,.85);lineHeight:24px;display:block;marginBottom:16px}.pStyle2[data-v-0ae60a48]{marginBottom:24px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
